import styled from 'styled-components';

export const Label = styled.div`
	color: #e30986;
	font-size: 1.3em;
	margin-bottom: .5em;
`;

export const LabelDescription = styled.div`
	color: #575757;
  font-size: .9em;
  p {
  	font-weight: bold;
  	margin: 0;
  }
  margin-bottom: .3em;
`;

export const Row = styled.div`
	padding-bottom: 10px;
	padding-top: 10px;
	position: relative;
`;

export const Wrapper = styled.div`
	padding: 5px;
`;



// WEBPACK FOOTER //
// ./src/html/controls/Form.js